import { render, staticRenderFns } from "./DeleteInspectionRoutePoint.vue?vue&type=template&id=6a72ee2a"
import script from "./DeleteInspectionRoutePoint.vue?vue&type=script&lang=js"
export * from "./DeleteInspectionRoutePoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports